import axios from 'axios';

/*
*  This file contains all axios calls related publish marketplace operations
*/

export const isExportable = async (funnelId) => {
    const publisherType = 'funnel';
    const { data } = await axios.get(`/app/contentPublishing/isExportable?publisherType=${publisherType}&publishId=${funnelId}`);

    return data;
};

export const mapArrayInfoToList = async (arrayInfo, allowAdd) => {
    const arrayList = [];

    if (allowAdd) {
        arrayList.push({
            label: 'Create New Listing',
            value: '0',
        });
    }

    Object.keys(arrayInfo).forEach((key) => {
        if (arrayInfo[key].id) {
            arrayList.push({
                label: arrayInfo[key].name,
                value: arrayInfo[key].id,
            });
        }
    });

    return arrayList;
};

export const loadCompaniesForCurrentUser = async () => {
    const { data } = await axios.get('/app/contentPublishing/getCompaniesForCurrentUser');
    const { companyResourceList } = data;

    return mapArrayInfoToList(companyResourceList, false);
};

export const getListingsForCompany = async (companyId) => {
    const { data } = await axios.get(`/app/contentPublishing/getContentListingsForCompany?companyId=${companyId}`);
    const { legacyListingResourceList } = data;

    return mapArrayInfoToList(legacyListingResourceList, true);
};

export const exportToMarketplace = async (funnelId, funnelName, privateListing, listingId, companyId) => {
    const publisherType = 'funnel';

    const { data } = await axios.post(
        '/app/contentPublishing/exportToMarketplace',
        `publisherType=${publisherType}&publishId=${funnelId}&artifactName=${funnelName}&privateListing=${privateListing}&listingId=${listingId}&companyId=${companyId}`,
    );

    return data;
};
